import React from 'react';
import { timeDiffIntervalForHumans } from '../../utils/utils';

export const DriverBreakStopItem = ({ driverStopInMin }) => {
  const timeInterval = timeDiffIntervalForHumans(driverStopInMin);

  return (
    <li className="timeline-item active timeline-item--no-icon">
      <div className="timeline-item-label col-12 mb-2 bg-primary">
        <p className="tx-07 lp mb-0 lh-1-3rem opa-05">{__('routes.driver_break')}</p>

        <p className="tx-11 text-bold-700 mb-1 lh-1-3rem">{timeInterval}</p>
      </div>
    </li>
  );
};
